/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantDomainBindingDto } from './TenantDomainBindingDto';
import {
    TenantDomainBindingDtoFromJSON,
    TenantDomainBindingDtoFromJSONTyped,
    TenantDomainBindingDtoToJSON,
    TenantDomainBindingDtoToJSONTyped,
} from './TenantDomainBindingDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface TenantDomainBindingListResponse
 */
export interface TenantDomainBindingListResponse {
    /**
     * 
     * @type {Array<TenantDomainBindingDto>}
     * @memberof TenantDomainBindingListResponse
     */
    data?: Array<TenantDomainBindingDto>;
    /**
     * 
     * @type {number}
     * @memberof TenantDomainBindingListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDomainBindingListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDomainBindingListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantDomainBindingListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantDomainBindingListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantDomainBindingListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the TenantDomainBindingListResponse interface.
 */
export function instanceOfTenantDomainBindingListResponse(value: object): value is TenantDomainBindingListResponse {
    return true;
}

export function TenantDomainBindingListResponseFromJSON(json: any): TenantDomainBindingListResponse {
    return TenantDomainBindingListResponseFromJSONTyped(json, false);
}

export function TenantDomainBindingListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDomainBindingListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TenantDomainBindingDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function TenantDomainBindingListResponseToJSON(json: any): TenantDomainBindingListResponse {
    return TenantDomainBindingListResponseToJSONTyped(json, false);
}

export function TenantDomainBindingListResponseToJSONTyped(value?: TenantDomainBindingListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TenantDomainBindingDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

